import { FunctionComponent, PropsWithChildren, useMemo } from "react";

import { v4 } from "uuid";

import { SessionContext } from "../contexts/SessionContext";

export const SessionContextProvider: FunctionComponent<
  PropsWithChildren & { setIsAdminTheme: React.Dispatch<React.SetStateAction<boolean>> }
> = ({ children, setIsAdminTheme }) => {
  const sessionId = useMemo(() => v4(), []);

  return (
    <SessionContext.Provider
      value={{
        sessionId,
        setIsAdminTheme,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
